<template>
    <b-container fluid class="">
        <b-row class="justify-content-between flex-center">
            <b-col cols="12" md="6">
                <h3>{{$t('sectors.title')}}</h3>
            </b-col>
            <b-col cols="12" md="6">
                <b-btn v-b-modal.createSector variant="primary" class="float-right"><span class="fa fa-plus mx-2"></span> {{$t('sectors.button')}}</b-btn>
            </b-col>
        </b-row>
        <hr/>
        
    <!-- <b-container fluid class="p-4 shadow-lg">
        <b-row class="w-100 noMargin justify-content-center">
                <b-col cols="6" md="3" class="eventDash m-2 p-2 text-center" v-for="sector in sectors" @click="goToSector(sector.id)">
                <b-row>
                    <b-col cols="4" class="flex-center">
                        <h5 class=""> {{ sector.code }} </h5>
                    </b-col>
                    <b-col cols="8">
                        <h6> {{$t('sectors.modal.row')}}: {{ sector.rows }} </h6>
                        <h6> {{$t('sectors.modal.spr')}}: {{ sector.row_seats }} </h6>
                    </b-col>
                </b-row>
            </b-col>
        </b-row> -->
    <b-container fluid class="">
        <b-row class="p-2 justify-content-center">
            <b-col cols="12" md="5" lg="3" class="eventDash m-2 p-4 shadow-lg" v-for="sector in sectors" >
                <b-row>
                    <b-col cols="9">
                    <b-card-title class="text-left">{{ sector.code }}</b-card-title>
                    </b-col>
                    <b-col cols="1" >
                        <i v-b-modal="'editSector'" user="'sector'" v-b-popover.hover.right="$t('sectors.sector.buttons.edit')" @click="sendInfo(sector)" class="far fa-edit"></i>
                    </b-col>
                    <b-col cols="1" >
                        <i v-b-modal="'deleteSector'" user="'sector'" v-b-popover.hover.right="$t('sectors.sector.buttons.delete')" @click="sendInfo(sector)" class="fas fa-trash-alt mx-2"></i>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="8">
                        <h6> {{$t('sectors.modal.row')}}: {{ sector.rows }} </h6>
                        <h6> {{$t('sectors.modal.spr')}}: {{ sector.row_seats }} </h6>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container >
<!--        <b-row v-if="sectors">-->
<!--            <b-col>-->
<!--                <events-table position-->
<!--                              search-key="code"-->
<!--                              :items="sectors"-->
<!--                              :fields="sectorFields"-->
<!--                              @rowClicked="">-->
<!--                </events-table>-->
<!--            </b-col>-->
<!--        </b-row>-->


        <b-modal centered
                 no-close-on-backdrop
                 id="createSector"
                 title=""
                 hide-footer>
                  <template v-slot:modal-title>
                    {{$t('sectors.title')}}
                 </template>
            <b-col md="12">
                <b-form @submit.prevent="createSector()" data-vv-scope="createSector">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group label-for="sectorCode">{{$t('sectors.modal.code')}}
                                <b-form-input :state="validateState('createSector.sectorCode')"
                                              :class="{'is-invalid': veeErrors.has('createSector.sectorCode')}"
                                              v-model="sector.code" v-validate="'required|alpha_num'" id="sectorCode" ref="sectorCode" type="text" size="md" name="sectorCode"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createSector.sectorCode') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="sectorRows">{{$t('sectors.modal.row')}}
                                <b-form-input :state="validateState('createSector.sectorRows')"
                                              :class="{'is-invalid': veeErrors.has('createSector.sectorRows')}"
                                              v-model="sector.rows" v-validate="'required|numeric|min_value:1'" id="sectorRows" ref="sectorRows" type="number" size="md" name="sectorRows"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createSector.sectorRows') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="sectorRowSeats">{{$t('sectors.modal.spr')}}
                                <b-form-input :state="validateState('createSector.rowSeats')"
                                              :class="{'is-invalid': veeErrors.has('createSector.rowSeats')}"
                                              v-model="sector.row_seats" v-validate="'required|numeric|min_value:1'" id="sectorRowSeats" ref="sectorRowSeats" type="number" size="md" name="rowSeats"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createSector.rowSeats') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" class="flex-center">
                            <b-form-group label-for="sectorPositionRadio"
                                          name="sectorPosition">{{$t('sectors.modal.position')}}<br>
                                <b-form-radio v-model="sector.position" v-validate="'required'" name="sectorPositionRadio" inline value="7">7</b-form-radio>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="8">8</b-form-radio>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="9">9</b-form-radio><br/>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" default inline value="4">4</b-form-radio>
                                <b-img :src="require('../../assets/img/soccerfield.png')" style="width: 50px;" fluid alt="field.png"/>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="6">6</b-form-radio><br/>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="1">1</b-form-radio>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="2">2</b-form-radio>
                                <b-form-radio v-model="sector.position" name="sectorPositionRadio" inline value="3">3</b-form-radio><br/>
                                <span class="vvError">{{ veeErrors.first('createSector.sectorPositionRadio') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="sectorSize">{{$t('sectors.modal.size')}}
                                <b-form-input :state="validateState('createSector.sectorSize')"
                                              :class="{'is-invalid': veeErrors.has('createSector.sectorSize')}"
                                              v-model="sector.size" v-validate="'required|numeric|min_value:1|max_value:12'" id="sectorSize" ref="sectorSize" type="number" size="md" name="sectorSize"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createSector.sectorSize') }}</span>
                                <b-form-text id="size-help-block">
                                    Min: 1, Max: 12 (12 {{$t('sectors.modal.in')}})
                                </b-form-text>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="sectorOrder">{{$t('sectors.modal.order')}}
                                <b-form-input :state="validateState('createSector.order')"
                                              :class="{'is-invalid': veeErrors.has('createSector.order')}"
                                              v-model="sector.order" v-validate="'required|numeric|min_value:1'" id="sectorOrder" ref="sectorOrder" type="number" size="md" name="order"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('createSector.order') }}</span>
                                <b-form-text id="rorder-help-block">
                                    {{$t('sectors.modal.nums')}}
                                </b-form-text>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="text-center">
                            <b-btn type="submit" :disabled="veeErrors.any('createSector')" variant="primary" class="w-50">{{$t('sectors.modal.button')}}</b-btn>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>
        <b-modal centered
                 no-close-on-backdrop
                 id="editSector"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('sectors.sector.title.edit')}}
                 </template>
            <b-form @submit.prevent="editSector()" data-vv-scope="editSector">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="sectorCode">{{$t('sectors.modal.code')}}
                            <b-form-input :state="validateState('editSector.sectorCode')"
                                          :class="{'is-invalid': veeErrors.has('editSector.sectorCode')}"
                                          v-model="selectedSector.code" v-validate="'required|alpha_num'" id="sectorCode" ref="sectorCode" type="text" size="md" name="sectorCode"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editSector.sectorCode') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editSector')" ref="btnEdit" variant="primary" class="w-50">{{$t('sectors.sector.buttons.conf')}}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal centered
                 id="deleteSector"
                 title=""
                 @ok="deleteSector"
                 ok-variant="danger">
                 <template v-slot:modal-title>
                    {{$t('sectors.sector.title.delete')}}
                 </template>
            <p class="my-4">{{$t('sectors.sector.title.msg')}}?</p>
        </b-modal>
    </b-container>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'users',
        data() {
            return {
                sector: {},
                selectedSector:'',
                printError: ('toast.printError'),
                sectors: null,
                sectorFields: [
                    {
                        key: 'code',
                        label: 'Code',
                        sortable: true
                    },
                    {
                        key: 'rows',
                        label: 'Rows',
                        sortable: true
                    },
                    {
                        key: 'row_seats',
                        label: 'Seats per row',
                        sortable: true
                    },
                ],
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            sendInfo(item) {
                this.selectedSector = item;
            },
            editSector(){
                this.$axios.post('sectors/updateById',{
                    params: {
                        id: this.selectedSector.id,
                        sector: this.selectedSector
                    }
                }).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : response.data.data.msg
                        });
                        this.$root.$emit('bv::hide::modal', 'editSector', '#btnEdit');
                    }else{
                        this.$toasted.global.err({
                            message : response.data.data.msg
                        });
                    }
                }).then(()=> {
                        this.$nextTick(() => {
                            this.veeErrors.clear();
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                        });
                    }
                );
            },
            deleteSector(){
                this.$axios.post('sectors/deleteById',{
                        params: {
                            id: this.selectedSector.id,
                            sector: this.selectedSector
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/sectors/')
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },
            createSector(){
                this.$validator.validateAll('createSector').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('sectors/create', {
                                params: {
                                    sector: this.sector,
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.sector = response.data.data;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                        }
                        );
                    }
                });
            },
            getSectors(){
                this.$axios.get('sectors').then(response => {
                    if (response.status === 200) {
                        this.sectors = response.data.data;
                    }
                })
            },
            goToSector(id) {
                this.$router.push('/sectors/' + id)
            },
        },
        created() {
            let self = this;
            this.getSectors();
            this.interval = setInterval(function () {
                self.getSectors();
            }, 5000);

        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>
